<template>
  <sa-page-layout :btnSaveVisible="false" :btnRouterBackVisible="true" :data="jsonData"
    :showModalLoading="showModalLoading" :pathResource="pathResource">
    <template slot="toolbar">
      <b-button variant="success btn-toolbar float-sm-right sa-margin-right" size="sm" v-if="isEdit && id == '-1'"
        @click="onClickSalva('onClickSave')"><b-icon icon="check2"></b-icon>Salva</b-button>
      <b-button variant="purple  btn-toolbar float-sm-right sa-margin-right" size="sm" v-if="isEdit && id == '-1'"
        @click="onClickSalva('onClickSave')"> <b-icon size="large" icon="building"></b-icon>Struttura</b-button>
    </template>

    <template slot="table-body">
      <b-modal ref="mdlChooseTipologiaRicetta" :title="'Struttura Riferimento'" size="medium"
        style="height: 100%; max-height: 100%; width: 100%; max-width: 100%" centered scrollable footer-tag="footer"
        no-close-on-backdrop no-close-on-esc hide-header-close>
        <b-card-text style="display: flex; justify-content: center; width: 100%">
          <accettazione-ssn-struttura-presidio-component :jsonData="jsonData.accettazione" :isEdit="!isEdit"
            @changeJsonData="onChangeStrutturaJSON"></accettazione-ssn-struttura-presidio-component>
        </b-card-text>
        <template #modal-footer>
          <div style="display: flex; justify-content: center; width: 100%">
            <b-button size="sm" v-b-tooltip.hover title="Conferma Struttura/Presidio/Regime"
              variant="danger btn-toolbar sa-margin-right" @click="onAnnullaConfermaStruttura()">
              <font-awesome-icon icon="times" />
              Annulla
            </b-button>
            <b-button size="sm" v-b-tooltip.hover title="Conferma Struttura/Presidio/Regime"
              variant="success btn-toolbar sa-margin-right" @click="onClickConfermaStrutturaRiferimento()"
              :disabled="isStrutturaSelected">
              <font-awesome-icon icon="check" />
              Conferma
            </b-button>
          </div>
        </template>
      </b-modal>
      <accettazione-ssn-edit-view-component ref="cmpAccettazioneEditViewComponent" :isEdit="isEdit" />
    </template>
  </sa-page-layout>
</template>

<script>
// import DatePicker from "vue2-datepicker";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import AccettazioneSsnEditViewComponent from "../components/AccettazioneSsnEditViewComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";

import AccettazioneSsnStrutturaPresidioComponent from "../components/AccettazioneSsnStrutturaPresidioComponent.vue";
import axios from "axios";

export default {
  mixins: [UtilityMixin],
  components: {
    SaPageLayout,
    AccettazioneSsnEditViewComponent,
    AccettazioneSsnStrutturaPresidioComponent,
  },
  computed: {
    isStrutturaSelected() {
      if (!this.jsonData.accettazione.codiceStruttura) {
        return true;
      } else if (!this.jsonData.accettazione.idPresidio) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      steps: ["Struttura", "Dematerializzata"],
      isDematerializzata: false,
      showModalLoading: false,
      pathResource: "/accettazionessn",
      linkback: "accettazionessn",
      linkNotBack: null,
      newLink: null,
      componentKey: 0,
      isFirstDematerializzata: false,
      isEdit: false,
      impegnativeKey: 0,
      id: null,
      tipologiaRicetta: null,
      pathResourceImpegnative: "/accettazionericette",
      jsonData: {
        cittadinanza: null,
        statoCivile: null,
        anonimato: true,
        stp: false,
        eni: true,
        conv: false,
        team: true,
        emailBox: true,
        sconosciuto: false,
        noteCaratteristichePaziente: null,
        rilasciatoDa: null,
        documento: null,
        partitaIva: null,
        identificazioneIstituzione: null,
        tipologiaDocumento: null,
        identificazioneTessera: null,
        scadenzaStpEni: null,
        scadenzaTessera: null,
        note: "",
        accettazione: {
          codiceStruttura: null,
          idPresidio: null,
          regime: null,
          settingCodice: null,
          settingDescrizione: null,
          accettazioniAsl: {
            aslDomicilioDistretto: "",
            aslResidenzaDistretto: "",
            aslResidenzaCodice: null,
            aslDomicilioCodice: null,
            aslDomicilioAmbito: "",
            aslResidenzaAmbito: "",
          },
          accettazioneAnagrafica: {
            identificativo: null,
            tipoIdentificativo: "CF",
            cognome: null,
            nome: null,
            sesso: null,
            dataNascita: null,
            comuneNascitaCodiceIstat: null,
            regioneResidenza: null,
            regioneDomicilio: null,
            comuneResidenzaCodiceIstat: null,
            comuneDomicilioCodiceIstat: null,
            indirizzoResidenza: null,
            indirizzoDomicilio: null,
            capResidenza: null,
            provinciaDomicilio: null,
            provinciaResidenza: null,
            provinciaNascita: null,
            capDomicilio: null,
            telefono: null,
            email: null,
            gruppoSanguigno: null,
            codiceFiscaleMedicoCurante: "",
            medicoCurante: "",
            emailMedicoCurante: "",
            medicoCuranteTelefono: "",
            linguaMadre: "",
            altreLingueParlate: "",
            note: "",
          },
        },
        ricette: [],
      },
      externaStepper: 1,
      step: 1,
    };
  },
  created() {
    let me = this;
    me.id = this.$route.params.id;
  },
  mounted() {
    let me = this;
    me.id = this.$route.params.id;
    me.isEdit = me.id == "-1" ? true : false;

    if (!me.isEdit) {
      me.loadData(me.id);
    } else {
      // me.$refs.mdlChooseTipologiaRicetta.show();
    }
  },

  methods: {
    onReload() {
      let me = this;
      me.loadData(me.id);
      me.isEdit = !me.isEdit;
    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onClickModifica() {
      let me = this;
      me.isEdit = !me.isEdit;
    },
    onAnnullaModifica() {
      let me = this;
      me.isEdit = false;
    },

    onClickSalva(metodo) {
      let me = this;
      me.jsonData.ricette.forEach((element) => {
        (element._showDetails = false), delete element._showDetails;
        element.codiceFiscaleAssistito = me.jsonData.accettazione.accettazioneAnagrafica.identificativo;
        if (element.prestazioni.length) {
          element.prestazioni.forEach((e) => {
            e.appuntamenti = e.appuntamentiTmp;
            delete e.appuntamentiTmp;
          });
        }
      });
      me.jsonData.identificazioneTessera = me.jsonData.documento;
      switch (metodo) {
        case "onClickSalvaModifica":
          me.onClickSalvaModifica();
          break;
        case "onClickSave":
          me.onClickSave();
          break;
        case "onClickSalvaModificaRicetta":
          me.onClickSalvaModificaRicetteAccettazione();
          break;
        default:
          break;
      }
    },
    onStepperUpdated(stepper) {
      this.step = stepper;
    },
    async onClickSalvaModificaRicetteAccettazione() {
      let me = this;
      if (me.jsonData.ricette.length > 0) {
        for (let ricetta of me.jsonData.ricette) {
          if (ricetta.id) {
            await axios
              .put(process.env.VUE_APP_PATH_API + "/accettazionericette/" + ricetta.id, ricetta)
              .then((response) => {
                response;
                console.log("response", response);
              })
              .catch((err) => {
                err;
                console.log("err", err);
              });
          } else {
            ricetta.idAccettazione = me.jsonData.id;
            await axios
              .post(process.env.VUE_APP_PATH_API + "/accettazionericette", ricetta)
              .then((response) => {
                response;
              })
              .catch((err) => {
                err;
              });
          }
        }
        //window.location.reload();
        me.onReload();
        me.isEdit = false;
      }
    },
    onSalvaRicetta(response) {
      console.log(response);
    },

    onSalvaRicettaError(response) {
      console.log(response);
    },
    onModificaRicetta(response) {
      console.log(response);
    },

    onModificaRicettaError(response) {
      console.log(response);
    },
    onClickSalvaModifica() {
      let me = this;
      axios
        .put(process.env.VUE_APP_PATH_API + me.pathResource + "/" + me.jsonData.id, me.jsonData)
        .then((response) => {
          me.$bvToast.toast("Tutto Ok", {
            title: "Salvataggio",
            variant: "success",
            solid: true,
          });
          this.$router.push("/accettazionessn/" + response.data.data.id);
          this.isEdit = false;
        })
        .catch((error) => {
          me.$bvToast.toast(error.response.data.messaggio, {
            title: "Errore",
            variant: "danger",
            solid: true,
          });
        });
    },
    onClickSave() {
      let me = this;
      axios
        .post(process.env.VUE_APP_PATH_API + me.pathResource, me.jsonData)
        .then((response) => {
          response;
          me.$bvToast.toast("Tutto Ok", {
            title: "Salvataggio",
            variant: "success",
            solid: true,
          });

          this.$router.push("/accettazionessn");
        })
        .catch((error) => {
          me.$bvToast.toast(error.response.data.messaggio, {
            title: "Errore",
            variant: "danger",
            solid: true,
          });
        });
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    onUpdateJsonRicette(json) {
      json;
    },
    onOpenModalStrutturaChoise() {
      let me = this;
      me.$refs.mdlChooseTipologiaRicetta.show();
      me.externaStepper = 1;
    },
    onAggiungiImpegnativa(json) {
      let me = this;
      me.jsonData.ricette.push(JSON.parse(JSON.stringify(json)));
      me.$refs.cmpAccettazioneImpegnativa.hide();
    },
    onChangeJsonStruttura(json) {
      let me = this;
      me.jsonData.codiceStruttura = json.codiceStruttura;
      me.jsonData.idPresidio = json.idPresidio;
    },
    onOpenModalImpegnativa() {
      let me = this;
      me.$refs.cmpAccettazioneImpegnativa.show();
    },
    onSiRicettaDematerializzata() {
      let me = this;
      me.$refs.mdlChooseTipologiaRicetta.hide();
      me.isDematerializzata = true;
      me.onOpenModalImpegnativa();
    },

    onNoRicettaDematerializzata() {
      let me = this;
      me.$refs.mdlChooseTipologiaRicetta.hide();
    },
    onChangeJsonDataAnagrafica(json) {
      let me = this;
      let accettazioneAnagrafica = json.accettazioneAnagrafica;
      let accettazioneAsl = json.accettazioniAsl;
      me.jsonData.accettazione.accettazioneAnagrafica = {
        id: accettazioneAnagrafica.id,
        primaryKey: accettazioneAnagrafica.primaryKey,
        idAccettazione: accettazioneAnagrafica.idAccettazione,
        tipo: accettazioneAnagrafica.tipo,
        createDate: accettazioneAnagrafica.createDate,
        createUser: accettazioneAnagrafica.createUser,
        proprietario: accettazioneAnagrafica.proprietario,
        identificativo: accettazioneAnagrafica.identificativo,
        tipoIdentificativo: "CF",
        cognome: accettazioneAnagrafica.cognome,
        nome: accettazioneAnagrafica.nome,
        dataNascita: accettazioneAnagrafica.dataNascita,
        sesso: accettazioneAnagrafica.sesso,
        provinciaNascita: accettazioneAnagrafica.provinciaNascita,
        comuneNascitaCodiceIstat: accettazioneAnagrafica.comuneNascitaCodiceIstat,
        regioneNascita: accettazioneAnagrafica.regioneNascita,
        telefono: accettazioneAnagrafica.telefono,
        email: accettazioneAnagrafica.email,
        regioneResidenza: accettazioneAnagrafica.regioneResidenza,
        provinciaResidenza: accettazioneAnagrafica.provinciaResidenza,
        comuneResidenzaCodiceIstat: accettazioneAnagrafica.comuneResidenzaCodiceIstat,
        indirizzoResidenza: accettazioneAnagrafica.indirizzoResidenza,
        capResidenza: accettazioneAnagrafica.capResidenza,
        regioneDomicilio: accettazioneAnagrafica.regioneDomicilio,
        provinciaDomicilio: accettazioneAnagrafica.provinciaDomicilio,
        comuneDomicilioCodiceIstat: accettazioneAnagrafica.comuneDomicilioCodiceIstat,
        indirizzoDomicilio: accettazioneAnagrafica.indirizzoDomicilio,
        capDomicilio: accettazioneAnagrafica.capDomicilio,

        emailMedicoCurante: "",
        medicoCuranteTelefono: "",
        gruppoSanguigno: accettazioneAnagrafica.gruppoSanguigno,
        medicoCurante: "",
      };
      me.jsonData.accettazione.accettazioniAsl = {
        aslDomicilioCodice: accettazioneAsl.aslDomicilioCodice == null ? "" : accettazioneAsl.aslDomicilioCodice,
        aslDomicilioDenominazione: accettazioneAsl.aslDomicilioDenominazione == null ? "" : accettazioneAsl.aslDomicilioDenominazione,
        aslDomicilioDistretto: accettazioneAsl.aslDomicilioDistretto == null ? "" : accettazioneAsl.aslDomicilioDistretto,
        aslDomicilioAmbito: accettazioneAsl.aslDomicilioAmbito == null ? "" : accettazioneAsl.aslDomicilioAmbito,
        aslResidenzaAmbito: accettazioneAsl.aslResidenzaAmbito == null ? "" : accettazioneAsl.aslResidenzaAmbito,
        aslResidenzaCodice: accettazioneAsl.aslResidenzaCodice == null ? "" : accettazioneAsl.aslResidenzaCodice,
        aslResidenzaDenominazione: accettazioneAsl.aslResidenzaDenominazione == null ? "" : accettazioneAsl.aslResidenzaDenominazione,
        aslResidenzaDistretto: accettazioneAsl.aslResidenzaDistretto == null ? "" : accettazioneAsl.aslResidenzaDistretto,
      };
    },
    onChangeJsonAccettazioneSsn(json) {
      let me = this;
      console.log("chanbge", json);
      me.jsonData.idAccettazione = json.idAccettazione;
      me.jsonData.statoCivile = json.statoCivile;
      me.jsonData.cittadinanza = json.cittadinanza;
      me.jsonData.noteCaratteristichePaziente = json.noteCaratteristichePaziente;
      me.jsonData.rilasciatoDa = json.rilasciatoDa;
      me.jsonData.documento = json.documento;
      me.jsonData.partitaIva = json.partitaIva;
      me.jsonData.identificazioneIstituzione = json.identificazioneIstituzione;
      me.jsonData.tipologiaDocumento = json.tipologiaDocumento;
      me.jsonData.scadenzaTessera = json.scadenzaTessera;
      me.jsonData.note = json.note;
    },
    onChangeStrutturaJSON(json) {
      let me = this;
      console.log(json);

      me.jsonData.accettazione.codiceStruttura = json.codiceStruttura;
      me.jsonData.accettazione.idPresidio = json.idPresidio;
      me.jsonData.accettazione.regime = json.regime;
      me.jsonData.accettazione.settingCodice = json.settingDescrizione;
    },
    changeJsonDataImpegnative(ricette) {
      let me = this;
      if (ricette.length >= 1) {
        ricette.forEach((element) => {
          element.codiceFiscaleAssistito = this.jsonData.accettazione.accettazioneAnagrafica.identificativo;
        });
      }

      me.jsonData.ricette = ricette;
    },
    onAnnullaConfermaStruttura() {
      this.$refs.mdlChooseTipologiaRicetta.hide();
      this.$router.push("/accettazionessn");
    },
    onIsTipologiaDematerilizzata(value) {
      let me = this;
      me.isDematerializzata = value;
    },

    onChangeTipologiaRicetta(tipologia) {
      tipologia;
    },
    onClickConfermaStrutturaRiferimento() {
      let me = this;
      me.externaStepper = 2;
    },
    onStepperStrutturaRicettaUpdated(value) {
      let me = this;
      me.externaStepper = value;
    },
    onAnnulla() {
      let me = this;
      me.isDematerializzata = false;
    },
    loadData() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, me.loadDataError);
    },
    loadDataSuccess(response) {
      let me = this;
      let reutnrVlaue = response.data.data;
      delete reutnrVlaue.accettazioneAnagrafica;
      delete reutnrVlaue.accettazionePrestazioni;
      delete reutnrVlaue.accettazioneStati;
      delete reutnrVlaue.accettazioneStruttura;
      delete reutnrVlaue.accettazionePresidio;
      delete reutnrVlaue.accettazioniAsl;
      me.jsonData = { ...reutnrVlaue };
    },
    loadDataError(error) {
      error;
    },
  },
};
</script>
